import { Button, ButtonProps } from '@sgme/ui';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { essentialQuoteCancelledThunk } from 'state/essential/thunks';

type CancelQuoteAction = { isDismiss?: boolean; iconOnly?: boolean } & ButtonProps;
export function CancelQuoteAction({ isDismiss = false, iconOnly = false, ...props }: CancelQuoteAction) {
  const { formId } = useQuote();

  const dispatch = useThunkDispatch();

  const cancelQuote: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    dispatch(essentialQuoteCancelledThunk(formId));
    logAnalytics.trackEvent('Primary market essential', 'Cancel quote (From status)');
  };

  return (
    <Button size="xl" {...props} onClick={cancelQuote}>
      {iconOnly ? (
        <i className="icon">clear</i>
      ) : (
        <FormattedMessage
          id={isDismiss ? 'sidePanel.actions.dismiss' : 'sidePanel.actions.cancel'}
          defaultMessage={isDismiss ? 'Dismiss' : 'Cancel'}
        />
      )}
    </Button>
  );
}
